import styled from 'styled-components'

export const NewGroupSubscriptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme['gray-300']};
    border-radius: 3px;
    margin-bottom: 24px;
    @media (min-width: 952px) {
        width: 710px;
        width: 930px;
    }
    @media (min-width: 1560px) {
        width: 1130px;
    }
    .subscriptions-header {
        padding: 13px 26px 20px 26px;
        border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
        display: flex;
        flex-direction: column;
        gap: 17px;
        .subscriptions-title {
            font-weight: 600;
            font-size: 14px;
        }
        .subscriptions-subtitle {
            font-weight: 600;
            font-size: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 8px;
        }
    }
`

export const BowtieSelector = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 32px;
`
